import { Link } from "react-router-dom";
import List from "@vapor/react-material/List";
import ListItem from "@vapor/react-material/ListItem";
import ListItemIcon from "@vapor/react-material/ListItemIcon";
import ListItemText from "@vapor/react-material/ListItemText";
import Box from "@vapor/react-material/Box";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";

export const NavContent = ({ basePath }) => (
  <Box sx={{ width: 250 }} role="presentation">
    <List>
      <ListItem button component={Link} to={basePath}>
        <ListItemIcon>
          <ManageAccountsIcon />
        </ListItemIcon>
        <ListItemText primary={"Lead Management"} />
      </ListItem>
    </List>
  </Box>
);
